import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard, faEyeSlash, faEye } from "@fortawesome/pro-light-svg-icons";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";
import { SortableContainer, SortableElement } from "react-sortable-hoc";

const SortableItem = SortableElement(({ value, handleHideClick }) => {
  const className = value.hidden && value.hidden === true ? "hidden bg-light" : "";
  if (value.categoryId === "category") {
    return (
      <ListGroup.Item className={className}>
        <a dangerouslySetInnerHTML={{ __html: value.name }} href={value.anchorLink}></a>
        <span onClick={handleHideClick} className="hide-icon">
          {value.hidden ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
        </span>
      </ListGroup.Item>
    );
  } else {
    return (
      <ListGroup.Item className={className}>
        <a
          dangerouslySetInnerHTML={{ __html: value.meta ? value.title.rendered : value.title }}
          href={value.meta ? value.meta.fl_article_url : value.website}
          target="_blank"
          rel="noreferrer"
        ></a>
        <span onClick={handleHideClick} className="hide-icon">
          {value.hidden ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
        </span>
        <div className="institution">{value.acf.fl_institution_shortname}</div>
      </ListGroup.Item>
    );
  }
});
const SortableList = SortableContainer(({ items, feedIndex, handleHideClick }) => {
  return (
    <ListGroup variant="flush">
      {items.map((value, index) =>
        value.categoryId === "category" ? (
          <SortableItem
            key={value.id}
            index={index}
            value={value}
            handleHideClick={() => handleHideClick(feedIndex, index)}
            collection={feedIndex}
          />
        ) : (
          <SortableItem
            key={value.id}
            index={index}
            value={value}
            handleHideClick={() => handleHideClick(feedIndex, index)}
            collection={feedIndex}
          />
        )
      )}
    </ListGroup>
  );
});

function Feed({
  name,
  categoryId,
  items,
  htmlString,
  articleCount,
  onSortEnd,
  feedIndex,
  handleHideClick,
}) {
  const wrapHtml = (insideHtml, feedName, categoryId) => {
    let categoryWrapperOpen;
    let categoryWrapperClose;
    if (categoryId === "category") {
      // Category Icon Feed
      categoryWrapperOpen = `<table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
      <tbody><tr>
        <td align="center" valign="top" style="padding:0 0 50px 0;">
          <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate !important;">
            <tbody><tr>
              <td height="0" align="center" valign="top" style="height:0; font-size:0; line-height:0; border-top:2px solid #F85F26;">&nbsp;</td>
            </tr>
          </tbody></table>
        </td>
      </tr>
    </tbody></table>`;
      categoryWrapperClose = `<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
      <tbody><tr>
        <td height="25" align="left" valign="top" style="height:25px; font-size:0; line-height:1px;">&nbsp;</td>
      </tr>
    </tbody></table>`;
    } else if (categoryId === 2) {
      // ASPPH News
      categoryWrapperOpen = ``;
      categoryWrapperClose = ``;
    } else if (categoryId === 8) {
      // School Programs & Updates
      categoryWrapperOpen = `<table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tbody>
          <tr>
            <td id="SchoolAndProgramUpdates" align="center" valign="top" style="padding:0 0 50px 0;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate !important;">
                <tbody><tr>
                  <td height="0" align="center" valign="top" style="height:0; font-size:0; line-height:0; border-top:2px solid #F85F26;">&nbsp;</td>
                </tr>
              </tbody></table>
            </td>
          </tr>
        </tbody>
      </table>
    
      <table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tbody>
          <tr>
            <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:28px; mso-line-height-rule:exactly; line-height:32px; color:#3D4F5D; padding:0 20px 25px 20px;">
              <strong>SCHOOL &amp; PROGRAM UPDATES</strong>
            </td>
          </tr>
        </tbody>
      </table>`;
      categoryWrapperClose = `<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tbody>
          <tr>
            <td class="paddingRightLeft20" align="center" valign="top" style="padding:0 0 25px 0;">
              <table class="widthFull" width="150" style="width:150px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                <tbody><tr>
                  <td align="center" valign="middle" height="40" bgcolor="#F85F26" style="height:40px; font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:16px; mso-line-height-rule:exactly; line-height:18px; color:#ffffff; padding:0 0 0 0;"><strong><a href="https://www.aspph.org/category/school-program-updates/" target="_blank" style="color:#ffffff; text-decoration:none; display:block; padding:11px 10px 11px 10px;">VIEW MORE &#9656;</a></strong></td>
                </tr>
              </tbody></table>
            </td>
          </tr>
        </tbody>
      </table>
    
    <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
      <tbody><tr>
        <td height="25" align="left" valign="top" style="height:25px; font-size:0; line-height:1px;">&nbsp;</td>
      </tr>
    </tbody></table>`;
    } else if (categoryId === 6) {
      // Members in the News
      categoryWrapperOpen = `<table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tbody>
          <tr>
            <td id="MembersInTheNews" align="center" valign="top" style="padding:0 0 50px 0;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate !important;">
                <tbody><tr>
                  <td height="0" align="center" valign="top" style="height:0; font-size:0; line-height:0; border-top:2px solid #F85F26;">&nbsp;</td>
                </tr>
              </tbody></table>
            </td>
          </tr>
        </tbody>
      </table>
      
      <table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tbody>
          <tr>
            <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:28px; mso-line-height-rule:exactly; line-height:32px; color:#3D4F5D; padding:0 20px 25px 20px;">
              <strong>MEMBERS IN THE NEWS</strong>
            </td>
          </tr>
        </tbody>
      </table>`;
      categoryWrapperClose = `<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tr>
          <td class="paddingRightLeft20" align="center" valign="top" style="padding:0 0 25px 0;">
            <table class="widthFull" width="150" style="width:150px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
              <tr>
                <td align="center" valign="middle" height="40" bgcolor="#F85F26" style="height:40px; font-family:'Source Sans Pro', Helvetica, sans-serif; font-size:16px; mso-line-height-rule:exactly; line-height:18px; color:#ffffff; padding:0 0 0 0;"><strong><a href="https://www.aspph.org/category/member-in-news/" target="_blank" style="color:#ffffff; text-decoration:none; display:block; padding:11px 10px 11px 10px;">VIEW MORE &#9656;</a></strong></td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tr>
          <td height="25" align="left" valign="top" style="height:25px; font-size:0; line-height:1px;">&nbsp;</td>
        </tr>
      </table>`;
    } else if (categoryId === 4) {
      // Global Action
      categoryWrapperOpen = `<table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tbody>
          <tr>
            <td id="GlobalAction" align="center" valign="top" style="padding:0 0 50px 0;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate !important;">
                <tbody><tr>
                  <td height="0" align="center" valign="top" style="height:0; font-size:0; line-height:0; border-top:2px solid #F85F26;">&nbsp;</td>
                </tr>
              </tbody></table>
            </td>
          </tr>
        </tbody>
      </table>
      
      <table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tbody>
          <tr>
            <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:28px; mso-line-height-rule:exactly; line-height:32px; color:#3D4F5D; padding:0 20px 25px 20px;">
              <strong>GLOBAL ACTION</strong>
            </td>
          </tr>
        </tbody>
      </table>`;
      categoryWrapperClose = `<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tr>
          <td class="paddingRightLeft20" align="center" valign="top" style="padding:0 0 25px 0;">
            <table class="widthFull" width="150" style="width:150px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
              <tr>
                <td align="center" valign="middle" height="40" bgcolor="#F85F26" style="height:40px; font-family:'Source Sans Pro', Helvetica, sans-serif; font-size:16px; mso-line-height-rule:exactly; line-height:18px; color:#ffffff; padding:0 0 0 0;"><strong><a href="https://www.aspph.org/category/global-action" target="_blank" style="color:#ffffff; text-decoration:none; display:block; padding:11px 10px 11px 10px;">VIEW MORE &#9656;</a></strong></td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tr>
          <td height="25" align="left" valign="top" style="height:25px; font-size:0; line-height:1px;">&nbsp;</td>
        </tr>
      </table>
      `;
    } else if (categoryId === 5) {
      // Member Research & Reports
      categoryWrapperOpen = `<table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tbody>
          <tr>
            <td id="MemberResearchAndReports" align="center" valign="top" style="padding:0 0 50px 0;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate !important;">
                <tbody>
                  <tr>
                    <td height="0" align="center" valign="top" style="height:0; font-size:0; line-height:0; border-top:2px solid #F85F26;">&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody></table>
        
        <table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
          <tbody>
            <tr>
              <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:28px; mso-line-height-rule:exactly; line-height:32px; color:#3D4F5D; padding:0 20px 25px 20px;">
                <strong>MEMBER RESEARCH &amp; REPORTS</strong>
              </td>
            </tr>
          </tbody>
        </table>`;

      categoryWrapperClose = `<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tr>
          <td class="paddingRightLeft20" align="center" valign="top" style="padding:0 0 25px 0;">
            <table class="widthFull" width="150" style="width:150px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
              <tr>
                <td align="center" valign="middle" height="40" bgcolor="#F85F26" style="height:40px; font-family:'Source Sans Pro', Helvetica, sans-serif; font-size:16px; mso-line-height-rule:exactly; line-height:18px; color:#ffffff; padding:0 0 0 0;"><strong><a href="https://www.aspph.org/category/member-research-reports/" target="_blank" style="color:#ffffff; text-decoration:none; display:block; padding:11px 10px 11px 10px;">VIEW MORE &#9656;</a></strong></td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tr>
          <td height="25" align="left" valign="top" style="height:25px; font-size:0; line-height:1px;">&nbsp;</td>
        </tr>
      </table>`;
    } else if (categoryId === 3) {
      // Faculty & Staff Honors
      categoryWrapperOpen = `<table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tbody>
          <tr>
            <td id="FacultyAndStaffHonors" align="center" valign="top" style="padding:0 0 50px 0;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate !important;">
                <tbody><tr>
                  <td height="0" align="center" valign="top" style="height:0; font-size:0; line-height:0; border-top:2px solid #F85F26;">&nbsp;</td>
                </tr>
              </tbody></table>
            </td>
          </tr>
        </tbody>
      </table>
    
      <table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tbody>
          <tr>
            <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:28px; mso-line-height-rule:exactly; line-height:32px; color:#3D4F5D; padding:0 20px 25px 20px;">
              <strong>FACULTY &amp; STAFF HONORS</strong>
            </td>
          </tr>
        </tbody>
      </table>`;
      categoryWrapperClose = `<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tr>
          <td class="paddingRightLeft20" align="center" valign="top" style="padding:0 0 25px 0;">
            <table class="widthFull" width="150" style="width:150px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
              <tr>
                <td align="center" valign="middle" height="40" bgcolor="#F85F26" style="height:40px; font-family:'Source Sans Pro', Helvetica, sans-serif; font-size:16px; mso-line-height-rule:exactly; line-height:18px; color:#ffffff; padding:0 0 0 0;"><strong><a href="https://www.aspph.org/category/faculty-staff-honors/" target="_blank" style="color:#ffffff; text-decoration:none; display:block; padding:11px 10px 11px 10px;">VIEW MORE &#9656;</a></strong></td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tr>
          <td height="25" align="left" valign="top" style="height:25px; font-size:0; line-height:1px;">&nbsp;</td>
        </tr>
      </table>`;
    } else if (categoryId === 9) {
      // Student & Alumni Achievements
      categoryWrapperOpen = `<table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tbody>
          <tr>
            <td id="StudentAndAlumniAchievements" align="center" valign="top" style="padding:0 0 50px 0;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate !important;">
                <tbody><tr>
                  <td height="0" align="center" valign="top" style="height:0; font-size:0; line-height:0; border-top:2px solid #F85F26;">&nbsp;</td>
                </tr>
              </tbody></table>
            </td>
          </tr>
        </tbody>
      </table>
      
      <table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tbody><tr>
          <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:28px; mso-line-height-rule:exactly; line-height:32px; color:#3D4F5D; padding:0 20px 25px 20px;">
            <strong>STUDENT &amp; ALUMNI ACHIEVEMENTS</strong>
          </td>
        </tr>
      </tbody></table>`;
      categoryWrapperClose = `<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tr>
          <td class="paddingRightLeft20" align="center" valign="top" style="padding:0 0 25px 0;">
            <table class="widthFull" width="150" style="width:150px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
              <tr>
                <td align="center" valign="middle" height="40" bgcolor="#F85F26" style="height:40px; font-family:'Source Sans Pro', Helvetica, sans-serif; font-size:16px; mso-line-height-rule:exactly; line-height:18px; color:#ffffff; padding:0 0 0 0;"><strong><a href="https://www.aspph.org/category/student-alumni-achievements/" target="_blank" style="color:#ffffff; text-decoration:none; display:block; padding:11px 10px 11px 10px;">VIEW MORE &#9656;</a></strong></td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tr>
          <td height="25" align="left" valign="top" style="height:25px; font-size:0; line-height:1px;">&nbsp;</td>
        </tr>
      </table>`;
    } else if (categoryId === 41) {
      // Events
      categoryWrapperOpen = "";
      categoryWrapperClose = "";
    } else if (categoryId === 7) {
      // Partner News
      categoryWrapperOpen = `<table bgcolor="#F85F26" width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
      <tbody><tr>
        <td id="PartnerNews" align="center" valign="top" style="padding:50px 0 25px 0;">
    
          <table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
            <tbody><tr>
              <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:28px; mso-line-height-rule:exactly; line-height:32px; color:#FFFFFE; padding:0 20px 25px 20px;">
                <strong>PARTNER NEWS</strong>
              </td>
            </tr>
          </tbody></table>`;
      categoryWrapperClose = `<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
            <tr>
              <td class="paddingRightLeft20" align="center" valign="top" style="padding:0 0 25px 0;">
                <table class="widthFull" width="150" style="width:150px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                  <tr>
                    <td align="center" valign="middle" height="40" bgcolor="#ffffff" style="height:40px; font-family:'Source Sans Pro', Helvetica, sans-serif; font-size:16px; mso-line-height-rule:exactly; line-height:18px; color:#F85F26; padding:0 0 0 0;"><strong><a href="https://www.aspph.org/category/partner-news/" target="_blank" style="color:#F85F26; text-decoration:none; display:block; padding:11px 10px 11px 10px;">VIEW MORE &#9656;</a></strong></td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

        </td>
      </tr>
      </table>`;
    }
    let wrappedHtmlString = categoryWrapperOpen + insideHtml + categoryWrapperClose;
    return navigator.clipboard.writeText(wrappedHtmlString);
  };

  return (
    <div className="Feed mb-4">
      <div class="d-flex justify-content-between">
        <h4>
          {name}

          <Button
            className="ml-2"
            size="sm"
            variant="outline-dark"
            onClick={() => wrapHtml(htmlString, name, categoryId)}
          >
            <FontAwesomeIcon icon={faClipboard} />
            &nbsp; Copy
          </Button>
        </h4>
        <p>Count: {articleCount}</p>
      </div>
      <Card style={{ maxHeight: "500px", overflowY: "scroll" }}>
        <SortableList
          pressDelay={100}
          items={items}
          onSortEnd={onSortEnd}
          feedIndex={feedIndex}
          handleHideClick={handleHideClick}
        />
      </Card>
    </div>
  );
}

export default Feed;
